import * as React from 'react';
import styles from './image.scss';

interface ObjectFitImageProps {
  src: string;
  alt?: string;
  className?: string;
  cover?: boolean;
  width?: number | string;
  height?: number | string;
  id?: string;
}

export const ObjectFitImage = ({ src, alt, className, cover, width, height, id }: ObjectFitImageProps) => {
  const handleOnError = (event: React.SyntheticEvent<HTMLImageElement, Event>) => {
    event.currentTarget.classList.add(styles.imageError);
  };
  const sizingStyle = cover ? styles.cover : styles.contain;
  const styleClassName = `image ${sizingStyle} ${className}`;
  return <img src={src} alt={alt} onError={handleOnError} className={styleClassName} width={width} height={height} id={id} />;
};
